<template>
  <div class="panel">
    <div class="u-flex-row u-space-between u-align-start">
      <h2>
        Recent Devices
      </h2>
      <div>
        <button class="btn btn-default" :disabled="!canLogoutOtherDevices" @click.prevent="logOutOnOtherDevices">
          Log out of all other devices
        </button>
      </div>
    </div>

    <p class="u-mb-x-large">
      Device sessions are stored for 90 days.
    </p>
    <simple-table
      :columns="columns"
      :rows="rows"
    >
      <template
        v-slot:device_os="{
          row
        }"
      >
        <i v-if="row.device_type === 'desktop'" class="far fa-desktop fa-fw" aria-hidden="true" />
        <i v-else-if="row.device_type === 'table'" class="far fa-tablet fa-fw" aria-hidden="true" />
        <i v-else-if="row.device_type === 'mobile'" class="far fa-mobile fa-fw" aria-hidden="true" />
        <span class="u-ml-x-small">{{ row.device_os }}</span>
      </template>
      <template
        v-slot:last_activity_at="{
          row
        }"
      >
        <date :value="row.last_activity_at" />
      </template>
    </simple-table>
  </div>
</template>

<script>
import { axios } from '@qlik-trial/automations-ui'
import { mapGetters } from 'vuex'
import { MessageLevel } from '@qlik-trial/automations-ui'
import LogoutOtherDevicesModal from './modals/LogoutOtherDevicesModal'
export default {
  props: ['initialSessions'],
  data() {
    return {
      sessions: this.initialSessions,
      columns: [
        {
          id: 'device_os',
          label: 'Device',
        },
        {
          id: 'ip_address',
          label: 'IP address',
        },
        {
          id: 'last_activity_at',
          label: 'Last activity at',
        },
      ],
    }
  },
  computed: {
    ...mapGetters([
      'isSuperAdmin',
      'isPowerAdmin',
    ]),
    canLogoutOtherDevices() {
      if (this.isSuperAdmin || this.isPowerAdmin) {
        return this.sessions.length > 1
      }

      return false
    },
    rows() {
      return this.sessions.map(session => {
        return {
          id: session.id,
          device_os: this.sessionDevice(session),
          device_type: session.device_type,
          ip_address: session.ip_address,
          last_activity_at: session.last_activity_at,
        }
      })
    },
  },
  methods: {
    logOutOnOtherDevices() {
      this.$store.dispatch('showCustomModal', {
        component: LogoutOtherDevicesModal,
        count: this.sessions.length - 1,
      }).then(password => {
        if (!password) {
          return
        }
        axios.post('/log-out-on-other-devices', {
          password,
        }).then(() => {
          return axios.get('/recent-devices')
        }).then(res => {
          this.sessions = res.data
          this.flash({
            message: 'You have been successfully logged out on all other devices.',
            level: MessageLevel.SUCCESS,
          })
        }).catch(error => {
          this.$store.dispatch('showErrorModal', {
            body: error.response.data.password[0] || 'Something went wrong. Please try again later.',
          })
        })
      })
    },
    sessionDevice(session) {
      return session.is_current ? `${session.device_os} - current` : session.device_os
    },
  },
}
</script>
